import * as React from "react"
import { Link } from "gatsby"
import Container from "../container/container"

import * as styles from "./boxes.module.scss"

const BotanicalBoxes = props => {
  const boxes = props.data
  return (
    <div className={styles.boxes}>
      <Container>
        <div
          className={`${styles.boxes__wrap} d-flex align-items-center justify-content-between`}
        >
          {boxes.map((box, key) => (
            <div className={styles.boxes__box} key={key}>
              <p>{box.Text}</p>
              <Link to={box.ButtonLink} className="cta">
                {box.ButtonText}
              </Link>
            </div>
          ))}
          {/* <div className={styles.boxes__box}>
            <p>Book a Clarity Call</p>
            <Link to="/contact" className="cta">
              Click here
            </Link>
          </div>
          <div className={styles.boxes__box}>
            <p>Purchase the Programme</p>
            <Link to="/contact" className="cta">
              Click here
            </Link>
          </div>
          <div className={styles.boxes__box}>
            <p>View Testimonials</p>
            <Link to="/" className="cta">
              Click here
            </Link>
          </div>
          <div className={styles.boxes__box}>
            <p>Menopause Rescue</p>
            <Link to="/" className="cta">
              Click here
            </Link>
          </div>
          <div className={styles.boxes__box}>
            <p>Other Service</p>
            <Link to="/" className="cta">
              Click here
            </Link>
          </div>
          <div className={styles.boxes__box}>
            <p>Other Service</p>
            <Link to="/" className="cta">
              Click here
            </Link>
          </div> */}
        </div>
      </Container>
    </div>
  )
}

export default BotanicalBoxes
